/**
 * Resolve the backend base URL.
 *
 * In a single-origin deployment (preview, subdomain Emergent, custom domain),
 * the backend lives on the same origin as the frontend, behind the `/api`
 * gateway. Hard-coding REACT_APP_BACKEND_URL at build time breaks once the
 * frontend is served from a different domain than the one baked into the
 * bundle (typical when a custom domain is linked after the first deploy).
 *
 * Resolution rules:
 *  1. SSR / build phase → use the env var (no `window` available)
 *  2. Browser → always use the current `window.location.origin`. This makes
 *     the bundle portable across any domain that fronts the app
 *     (cabinet-echo.com, *.emergent.host, *.preview.emergentagent.com, etc.).
 *
 * The env var is still used as a build-time hint for SSR / prerender.
 */
export const getBackendUrl = () => {
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }
  return process.env.REACT_APP_BACKEND_URL || "";
};

export const getApiBase = () => `${getBackendUrl()}/api`;
